import {
  Modal,
  Card,
  CardContent,
  Typography,
  Stack,
  Button,
} from "@mui/material";

interface Props {
  openModal: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmQuantityDiscountResetModal = (props: Props) => {
  return (
    <Modal
      open={props.openModal}
      onClose={props.onCancel}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        sx={{
          height: "30vh",
          width: { md: "40%", xs: "70%" },
        }}
      >
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6">Alterar quantidade?</Typography>
            <Typography variant="body2">
              Ao alterar a quantidade, os descontos deste item serao removidos.
              Sera necessario informar o desconto novamente.
            </Typography>
            <Stack direction={"row"} justifyContent={"space-around"}>
              <Button
                variant="outlined"
                color="success"
                onClick={props.onConfirm}
              >
                Confirmar
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={props.onCancel}
              >
                Cancelar
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default ConfirmQuantityDiscountResetModal;
